import React from 'react'
import MainContainer from '../../components/main-container/main-container.component'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Logo from '../../components/logo/logo.components';
import { GrUserAdmin } from 'react-icons/gr';


function CommunityGuidelines() {
  return (
    <main
      className="container-fluid forgot-password-container pb-4"
      style={{ height: "auto" }}
    >
      <nav className="navbar fixed-top navbar-light">
        <Link
          to="/"
          className="navbar-brand"
          style={{ fontSize: "22px", color: "#ffffff" }}
        >
          <Logo size="small" />
        </Link>

        <Link
          to="/"
          className="btn btn-primary btn-login  my-2 my-sm-0 px-4 rounded-10"
          type="submit"
        >
          <GrUserAdmin size="1.2em" style={{ marginRight: "5px" }} /> Login
        </Link>
      </nav>
      <article className="container mt-5 pt-5">
        <div className="billing-container text-white">
          <div className="row">
            <div className="col-12">
              <h1>3for3 Networking Community Guidelines</h1>

              <div className="text-white mt-3">
                <p>
                  <strong>Effective Date: May 13, 2025</strong>
                </p>
                <p>
                  <strong>Last Updated: May 13, 2025</strong>
                </p>
              </div>

              <p>
                At 3for3 Networking, you're not just joining a platform — you're
                joining a community of real people who believe in real
                conversations. We exist to help professionals grow through
                meaningful connections, shared experiences, and trusted
                relationships that lead to business growth.
              </p>

              <p>
                To keep this community valuable, respectful, and aligned with
                our mission, we've outlined the following guidelines. These are
                here to protect the people in our network, uphold the culture of
                giving, and create a space where everyone feels welcome and
                heard.
              </p>

              <h2>
                <u>Our Core Principles</u>
              </h2>
              <ul>
                <li>
                  <b>Show Up Consistently</b> - Be present, be genuine, and
                  follow through.
                </li>
                <li>
                  <b>Respect Others</b> - Every voice matters. Diversity
                  strengthens us.
                </li>
                <li>
                  <b>Build Trust</b> - Strong relationships are the foundation
                  of everything we do.
                </li>
                <li>
                  <b>Grow Together</b> - Share insights, lend support, and
                  celebrate wins.
                </li>
              </ul>

              <h2>
                <u>Member Expectations</u>
              </h2>

              <ol>
                <li>
                  <b>Be Authentic & Engage Intentionally</b>
                  <ul>
                    <li>Attend meetings consistently and be fully present.</li>
                    <li>
                      Schedule 1-on-1s, join Table discussions, and stay active
                      in your network.
                    </li>
                    <li>
                      Prepare for meetings with purpose — give updates, ask
                      questions, and support others.
                    </li>
                    <li>
                      Be yourself. Real connections come from honesty, not
                      performance. Don't create fake accounts or pretend to be
                      someone you're not.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Contribute Value First</b>
                  <ul>
                    <li>
                      Focus on helping, teaching, learning, or guiding other
                      members first.
                    </li>
                    <li>
                      Make quality introductions, share referrals, and offer
                      thoughtful advice.
                    </li>
                    <li>
                      Celebrate other's growth and support their challenges.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Treat Referrals as Relationships</b>
                  <ul>
                    <li>Respond promptly and professionally to referrals.</li>
                    <li>Keep referrers informed on how things progress.</li>
                    <li>
                      Deliver your best work and reflect positively on the
                      person who trusted you.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Respect Everyone, Always.</b>
                  <ul>
                    <li>
                      Discrimination, harassment, or exclusion will not be
                      tolerated.
                    </li>
                    <li>
                      Appreciate the diversity of backgrounds, perspectives, and
                      business styles.
                    </li>
                    <li>
                      Communicate with kindness. Listen actively. Assume good
                      intent.
                    </li>
                    <li>
                      Let connections grow at their own pace — don't rush
                      relationships.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Be Transparent and Honest</b>
                  <ul>
                    <li>Represent your business clearly and authentically.</li>
                    <li>
                      Don't overpromise or oversell. Be upfront about capacity
                      and timelines.
                    </li>
                    <li>
                      Communicate changes, delays, or concerns directly and
                      professionally.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Protect Privacy and Confidentiality</b>
                  <ul>
                    <li>
                      Don't share personal, client, or member information
                      without permission.
                    </li>
                    <li>
                      Respect the trust that comes with every connection made on
                      this platform.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Use the Platform Appropriately</b>
                  <ul>
                    <li>
                      No scams, misleading information, or illegal activity of
                      any kind.
                    </li>
                    <li>
                      No spamming, pitching inappropriately, or soliciting
                      without context.
                    </li>
                    <li>
                      No false Reporting. We rely on users to report bad
                      behaviour, do not misuse this tool.
                    </li>
                  </ul>
                </li>
              </ol>

              <h2>
                <u>Our Commitment to You</u>
              </h2>

              <p>
                3for3 Networking is committed to cultivating a trusted,
                respectful space for connection and growth. If something feels
                off, whether it's a message, referral, or behavior, please let
                us know. If you witness or experience misconduct that violates
                these guidelines or our Terms of Service, contact us
                immediately. Breaches of these expectations may result in
                action, including removal from the platform.
              </p>

              <p>
                We are building a space where professionals don't just grow
                their business — they grow with each other. A place where
                honesty, effort, and generosity open doors.
              </p>

              <p>We're here to create something better. Together.</p>

              <p>Thank you for choosing 3for3 Networking.</p>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}

export default CommunityGuidelines